import { useCallback } from "react";

import useTypedContext from "hooks/useTypedContext";
import { AccountContext } from "views/AccountWrapper";
import { Action, Module } from "types/generated";
import { AccessResult, NO_ACCESS_MESSAGE, hasAtLeastOneRequiredAction } from "utils/access";

const DISABLE_MODULE_ACCESS_TYPES = [Action.SpaceAdmin, Action.ModuleDisable];

const useCanDisableModule = (): ((module: Module) => AccessResult) => {
  const { viewer } = useTypedContext(AccountContext);

  return useCallback(
    (module: Module) => {
      if (module.isDisabled) {
        return { result: false };
      }

      if (viewer.admin) {
        return { result: true };
      }

      const spaceId = module.spaceDetails?.id || module.space;
      const result = hasAtLeastOneRequiredAction(DISABLE_MODULE_ACCESS_TYPES, viewer, spaceId);

      if (result) {
        return { result: true };
      }

      return { result: false, message: NO_ACCESS_MESSAGE };
    },
    [viewer]
  );
};

export default useCanDisableModule;
